
import ltRest from "lt-request";
import { message } from "ant-design-vue";
const LtRest = new ltRest();
import { useI18n } from '@/hooks/useI18n';
/* eslint-disable */
//@ts-ignore
const { t } = useI18n()

export const commonSaveData = async function (url: string, data: any) {
  return await LtRest.post(url, data).then((res) => {
    message.success(t("common.SaveSuccess"))
    /* eslint-disable */
    //@ts-ignore
    return res.Result
  }).catch((err) => {
    //message.error(err)
    return false
  })
}

export const commonDelData = async function (url: string, data: any) {
  return await LtRest.delete(url, { data: data }).then((res) => {
    message.success(t("common.DelSuccess"))
    /* eslint-disable */
    //@ts-ignore
    return res.Result
  }).catch((err) => {
    //message.error(err)
    return false
  })
}




